const mappings = {
  mapping_configuration: "Mapping Configuration",
  view_mapping_details: "View mapping details",
  mapping_details: "Mapping details",
  mappings: "Mappings",
  mapping_not_created: `Mapping not created`,
  mapping_download_request_inprocess: `Download request in process`,
  description_max_length: `Description must be at most 100 characters`,
  notes: `Notes`,
};
export default mappings;
